<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title class="izy-day-title">
  <mat-icon>event</mat-icon>
  <span>{{ data.day.date | date: 'fullDate' }}</span>
</h2>

<mat-dialog-content>
  @if (data.day.events.length === 0) {
    <!-- Stesso riquadro panna delle voci, in tinta spenta: un giorno senza
         scadenze non e' un errore da segnalare in rosso. -->
    <div class="izy-day-empty izy-sharp-bl">
      <mat-icon>event_available</mat-icon>
      <span>Nessun evento in programma per questo giorno</span>
    </div>
  } @else {
    <!-- Ogni evento e' un riquadro a se', bordato nero 2px con l'angolo
         basso-sinistra vivo: la stessa grammatica dei riquadri dell'app.
         Il colore dell'evento resta sulla sola pastiglia a sinistra, cosi' il
         tipo si riconosce a colpo d'occhio senza colorare tutto il blocco. -->
    <ul class="izy-day-list">
      @for (event of data.day.events; track $index) {
        <li class="izy-day-item izy-sharp-bl">
          <span
            class="izy-day-dot"
            [style.background-color]="event.color?.primary"></span>

          <div class="izy-day-text">
            <span class="izy-day-event-title">{{ event.title }}</span>
            <span class="izy-day-event-time">
              {{ event.start | date: 'shortTime' }}
              @if (event.end) {
                &ndash; {{ event.end | date: 'shortTime' }}
              }
            </span>
          </div>
        </li>
      }
    </ul>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Chiudi
  </button>
</mat-dialog-actions>
